import React, { useEffect } from "react";

import "./Loader.scss";
export default function Loader({message,spinner}) {

  // console.log(message);


  useEffect(() => {
    if (!message) return;
    const textElement = document.getElementById('animated-text');
    if(textElement){
      textElement.innerHTML = message?.split('').map((char, index) => {
        // Check if the character is a space and return it as a separate span with no animation delay
        if (char === ' ') {
          return `<span style="display:inline-block; width: 10px;"></span>`;
        }
        return `<span style="animation-delay: ${index * 0.1}s">${char}</span>`;
      }).join('');
    }
  }, [message]);

  
  
  return (
    <div className="w-100 d-flex justify-content-center align-items-center flex-column" style={{ overflowX: "hidden"}}>
     {!spinner && message === undefined &&  <div
        style={{
          padding: "20px",
          // margin: "10px 47%",
          // display: "inline-flex",
        }}
      >
      
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="56"
          viewBox="0 0 31 28"
          fill="none"
        >
          <path
            d="M23 3h-9C7.925 3 3 7.925 3 14v0c0 6.075 4.925 11 11 11h9M21 14h7"
            stroke="var(--leading-color)"
            className="path"
            strokeWidth="6"
            strokeLinecap="round"
          ></path>
           
        </svg>
      </div>}
      <div style={{width:spinner ? "190px" : ""}}>{message ? <p id="animated-text" className="animated-text"></p> : null}</div>
    </div>
  );
}
